var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_header"},[_c('Navigation',{attrs:{"msg":"Uplata"}}),_c('div',{staticClass:"round"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('location'))+" "),_c('strong',[_vm._v(_vm._s(_vm.locationShortCode))])])]),_c('RightSide')],1)}
var staticRenderFns = []

export { render, staticRenderFns }